import { ComponentProps, forwardRef } from 'react';
import { Stack, StackProps, styled, SxProps, Typography } from '@mui/material';
import { COLOR_BG_BLACK } from 'shared/config';
import { CopyButton } from 'shared/ui/copyButton';

export const BlackPlate = styled(Stack)<StackProps>(({ theme }) => ({
  backgroundColor: COLOR_BG_BLACK,
  width: '100%',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  borderRadius: theme.shape.borderRadius * 2,
  padding: theme.spacing(1, 1.5),
  gap: theme.spacing(1),
  overflow: 'hidden',
}));

type Props = {
  copyValue: string;
  displayValue: string;
  successCopyMessage?: string;
  btnSx?: SxProps;
  disabled?: boolean;
} & StackProps;

const CopyField = forwardRef<HTMLElement, Props>(
  ({ copyValue, btnSx, successCopyMessage, displayValue, disabled = false, ...props }, ref) => {
    return (
      <BlackPlate ref={ref as ComponentProps<typeof BlackPlate>['ref']} {...props}>
        <Typography variant="body2" className="secondary" noWrap>
          {displayValue}
        </Typography>
        <CopyButton disabled={disabled} text={copyValue} successText={successCopyMessage} sx={btnSx} />
      </BlackPlate>
    );
  },
);

export default CopyField;
